import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  errorData: {
    show: false,
    msg: "",
    status: null,
    // Redirecting to URL after closing Error Modal
    url: "",
    buttonName: "Close",
    isSuccess: false,
  },
};

export const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setErrorData: (state, action) => {
      state.errorData = action.payload;
    },
    clearErrorData: (state) => {
      state.errorData = initialState.errorData;
    },
    removeReduxData: () => {
      // Note that this should be left intentionally empty.
      // Clearing redux state and localForage happens in store.js.
    },
  },
});

export const { setErrorData, clearErrorData, removeReduxData } =
  errorSlice.actions;

export const getErrorDataSelector = (state) => state.error.errorData;

export default errorSlice.reducer;
